<script setup lang="ts">
import { User, UserMessage } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersActions, UsersMutations, UsersState } from '@/stores/users.store';
import { format } from 'date-fns';
import { computed, PropType, ref, watch } from 'vue';
import { useStore } from 'vuex';

const store = useStore<ShiftCMSState & { us: UsersState }>();
const messages = computed<UserMessage[]>(() => store.state.us.userMessages);
const loaded = ref<boolean>(false);

const props = defineProps({
  user: {
    type: Object as PropType<User>,
    required: true,
  },
});

function loadMessages() {
  store.dispatch(UsersActions.GetMessages, props.user.id);
  loaded.value = true;
}

watch(
  () => props.user,
  () => {
    store.commit(UsersMutations.SetMessages, []);
    loaded.value = false;
  },
);

const headers = [
  { title: 'ID', key: 'id', sortable: false, width: '5%' },
  { title: 'Date', key: 'creationDate', width: '20%' },
  { title: 'Type', key: 'type', width: '10%' },
  { title: 'Text', key: 'messageText', width: '55%' },
];
</script>
<template>
  <v-card class="mt-4" v-if="user.id !== -1">
    <v-card-title>Messages</v-card-title>
    <v-card-text v-if="!messages.length && !loaded">
      <v-btn @click="loadMessages" color="info" density="compact"
        >See user messages</v-btn
      >
    </v-card-text>
    <v-card-text v-else>
      <v-data-table :items="messages" :headers="headers">
        <template v-slot:item.creationDate="{ value }">
          {{ format(value, 'dd-MM-yyyy - HH:mm') }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
